import { Component, OnInit, NgZone  } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ReportService } from '../../core/http/report.service';
import { Router } from '@angular/router';
import { Md5 } from 'ts-md5/dist/md5';
import {MatSnackBar} from '@angular/material/snack-bar';


const MD5 = new Md5();

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  isLoading = false;
  loginErrors = null;
  data = null;
  mode = "pass"

  forgot() {
    this.mode = "pass"
  }

  login() {
    this.mode = "login"
  }


  loginForm = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
  });

  Form = new FormGroup({
    Current_Password: new FormControl('', Validators.required),
    New_Password: new FormControl('', Validators.required),
  });

  constructor(
    public report:ReportService,
    public router: Router,
    private zone: NgZone,
    private _snackBar: MatSnackBar
  ) { }

  Submit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.loginErrors = null;
    const {
      Current_Password,
      New_Password,
    } = this.Form.value;
    this.report
      .changepassword(
        Current_Password,
        New_Password,
      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;
          console.log(resSuccess);


          console.log("user object" , this.data);
          if (this.data.success) {
            this.Form.reset()
            this._snackBar.open('Password changed Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            // window.location.href = "/register";
          }
          else {
            this._snackBar.open('Error: please try again', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }

        },
        (resErr) => {
          this.isLoading = false;
          this.loginErrors = resErr;
          this._snackBar.open(resErr, '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
  }

  // onSubmit(e) {
  //   e.preventDefault();
  //   this.isLoading = true;
  //   this.loginErrors = null;
  //   const {
  //     username,
  //     password,
  //   } = this.loginForm.value;
  //   this.auth
  //     .login(
  //       username,
  //       MD5.appendStr(password).end(),
  //     )
  //     .subscribe(
  //       (resSuccess) => {

  //         this.data = resSuccess
  //         this.isLoading = false;

  //         console.log("user object" , this.data);
  //         if (this.data.success) {
  //           localStorage.setItem('token', this.data.userobj.user_token);
  //           localStorage.setItem('role', this.data.userobj.rolename);
  //           localStorage.setItem('id', this.data.userobj.userid);
  //           localStorage.setItem('username', this.data.userobj.username);
  //           this.auth.setLogedin(true);
  //           window.location.href = "/register";
  //         }
  //         else {
  //           this.loginErrors = this.data.message
  //         }

  //       },
  //       (resErr) => {
  //         this.isLoading = false;
  //         this.loginErrors = resErr;
  //       }
  //     );
  // }


  ngOnInit(): void {
  }


}
